import * as React from "react";
import styled, { css } from "styled-components";

import {
  IApiError,
  breakpoint
} from "src/library/utils";

import { Text } from "../Text";
import TableError from "./TableError";

const TableNoDataStyled = styled.div`
  ${({ theme }) => css`
    position: absolute;
    pointer-events: none;
    z-index: 10;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    p {
      transition: ${({ theme }) => theme.transition.quicker};
      position: relative;
      top: 50%;
      transform: translateY(-50%);
      margin: 0;
      padding: 0;
      text-align: center;

      ${breakpoint("md", theme)} {
        font-size: ${theme.fonts.sizes.h3};
      }

      strong {
        font-weight: ${({ theme }) => theme.fonts.weights.bold};
      }
    }
  `}
`;

interface TableNoDataProps {
  error?: IApiError | null;
  onRetry?: () => void;
}

const TableNoData: React.ReactFCWithChildren<TableNoDataProps> = ({ error, onRetry }) => {
  // Return the error if one exists
  if (error) {
    return (
      <TableError
        error={error}
        onRetry={onRetry ? onRetry : () => window.location.reload()}
      />
    );
  }

  return (
    <TableNoDataStyled className="rt-no-data">
      <Text as="p">
        No entries were found.
      </Text>
    </TableNoDataStyled>
  );
};

export default TableNoData;
